import React from 'react';
import PropTypes from 'prop-types';
import CreateChannelModal from '../CreateChannelModal';
import ChannelsAtCenterList from './ChannelsAtCenterList';
import { Query, Mutation } from 'react-apollo';
import { GET_CHANNELS } from '../../../graphql/queries';
import { JOIN_CHANNEL } from '../../../graphql/mutations';

const CenterChannelsModal = ({
  isOpen,
  onClose,
  selectChannel,
  ...props
}) => {
  const handleChannelJoin = (cache, { data: { joinChannel } }) => {
    // read current channels data from the cache
    let { getChannels } = cache.readQuery({ query: GET_CHANNELS });
    const cachedChannelIds = getChannels.map(channel => channel.id);
    const { channel: channelToAdd } = joinChannel;

    /**
     * there is a bug with react-apollo and appsync where `update` for mutations causes the duplicates to be added into the cache
     * - once with the actual server response and once with the optimistic ui
     * - if the new channel id has already been added, simply don't add it again
     */
    if (!cachedChannelIds.includes(channelToAdd.id)) {
      // add new channel
      getChannels.push(channelToAdd);
      // write updated data back to the cache
      cache.writeQuery({
        query: GET_CHANNELS,
        data: {
          getChannels
        }
      });
    }

    // bubble selection up so that it is selected in the sidebar
    selectChannel(channelToAdd.id, channelToAdd);
  };

  return (
    <Mutation
      mutation={JOIN_CHANNEL}
      onCompleted={onClose}
      update={handleChannelJoin}
    >
      {(joinChannel) => (
        <CreateChannelModal
          isOpen={isOpen}
          onClose={onClose}
          title='Browse Channels'
          subtitle='These are all of the channels you can join'
          showCreateChannelButton={false}
        >
          <Query
            query={GET_CHANNELS}
            fetchPolicy='cache-only'
          >
            {({ data: { getChannels } }) => (
              <ChannelsAtCenterList
                selectChannel={channel => {
                  joinChannel({
                    variables: {
                      channelId: channel.id
                    }
                  });
                }}
                existingChannelMembershipIds={getChannels.map(channel => channel.id)}
              />
            )}
          </Query>
        </CreateChannelModal>
      )}
    </Mutation>
  );
};

CenterChannelsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  selectChannel: PropTypes.func // once a channel has been joined, select it in the sidebar
};

export default CenterChannelsModal;
